<template>
  <!--
    @name: detail.vue
    @description: 文章详情页
    @author:  GaoYu
    @time: 2020/7/28 11:36
  -->
  <div class="article-container">

    <HeaderWithBtn :app-url="appUrl"></HeaderWithBtn>

    <div :class="typeClass">
      <div class="content-box">
        <div class="article-box">
          <div v-if="isDel" style="width: 100%">
            <div class="del-box">该文章已被删除</div>
          </div>
          <div class="article-video" v-if="!isDel && detail.article_type === 2"><my-video ref="video"></my-video></div>
          <div :class="typeClass2" v-if="articleType">
            <div class="serial-tag" v-if="detail.type === 2">连载</div>
            <div class="title">{{detail.title}}</div>
            <div class="author-box">
              <div class="author-img">
                <img :src="detail.user_avater" alt="">
                <img class="vip"  v-if="detail.article_user_type === 1" src="../../assets/image/article/vip.png" alt="">
              </div>
              <div class="describe-box">
                <div class="name">{{ detail.nickname }}</div>
                <div class="describe">
                  <span>优质创作者</span>
                  <span class="time">{{detail.push_time}} 发布</span>
                </div>
              </div>
            </div>
          </div>
          <article-detail :detail-list="list" :detail-content="detail"></article-detail>
          <related-recommendations :detail-relative="relative"></related-recommendations>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import HeaderWithBtn from '../../components/Common/HeaderWithBtn'
import ArticleDetail from '../../components/Article/ArticleDetail'
import RelatedRecommendations from '../../components/Article/RelatedRecommendations'
import MyVideo from '../../components/Common/MyVideo'

import { getArticleDetailApi } from '@/api/article'

export default {
  name: 'detail',
  data () {
    return {
      id: this.$route.params.id,
      appUrl: 'eestar://eestar/article_detail?article_id=' + this.$route.params.id,
      detail: {
      },
      list: [],
      relative: []
    }
  },
  computed: {
    isDel () {
      return this.detail.status === -1
    },
    articleType () {
      return ((!this.isDel && this.detail.article_type === 1) || (!this.isDel && this.detail.article_type === 2))
    },
    typeClass () {
      if (this.detail.article_type === 1) {
        return 'text-container'
      } else if (this.detail.article_type === 2) {
        return 'video-container'
      }
    },
    typeClass2 () {
      if (this.detail.article_type === 1) {
        return 'title-box'
      } else if (this.detail.article_type === 2) {
        return 'video-content'
      }
    },
    goAppText () {
      if (this.detail.article_type === 1) {
        return '打开“电子星球”查看全文'
      } else {
        return '打开“电子星球”观看更多视频'
      }
    }
  },
  components: {
    ArticleDetail,
    RelatedRecommendations,
    MyVideo,
    HeaderWithBtn
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      getArticleDetailApi({
        article_id: this.id
      }).then(res => {
        if (res.code === this.$config.codeOk) {
          this.detail = res.data.detaile
          this.list = res.data.list
          this.relative = res.data.relative
          // 是否有视频
          if (this.detail.article_type === 2) {
            setTimeout(() => {
              this.$refs.video.createPlayer({
                rePlay: false,
                source: this.detail.video
              })
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .article-container {
    width: 100%;
    overflow: hidden;
    .del-box {
      width: 100%;
      text-align: center;
      height: 436px;
      line-height: 436px;
      font-size: 15px;
      color: #999999;
    }

    .text-container {
      display: flex;
      width: 100%;
      flex-flow: row wrap;
      background: #ffffff;
      overflow: hidden;
      margin-top: 25px;
    }

    .content-box {
      width: 100%;
      align-self: flex-start;
      .article-box {
        padding: 0 0 15px;

        .title-box {
          padding: 0 16px;
          .serial-tag {
            width:32px;
            height:18px;
            line-height: 18px;
            background: #3782FE;
            border-radius:3px;
            color: #ffffff;
            font-size:11px;
            text-align: center;
            margin-bottom: 5px;
          }
        }
      }
    }

    .author-box {
      margin-bottom: 15px;
      display: flex;
      .author-img {
        flex: 0 0 36px; /* 左侧固定200px */
        background: #ffffff;
        height: 36px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .vip {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 14px;
          height: 14px;
          z-index: 99999;
        }
      }
      .describe-box {
        flex: 1;
        margin-left: 5px;
        .name {
          font-size: 13px;
          height: 18px;
          line-height: 18px;
          color: #333333;
        }
        .describe {
          margin-top: 2px;
          font-size: 11px;
          height: 16px;
          line-height: 16px;
          color: #999999;
          .time {
            margin-left: 10px;
          }
        }
      }
    }

    .title {
      margin-bottom: 15px;
      line-height: 30px;
      font-size: 22px;
      font-weight: bold;
      color: #333333;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .video-container {
      .article-video {
        height: 211px;
        width: 100%;
        margin-bottom: 15px;
      }
      .video-content {
        padding: 0 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/article/detail.vue